import {
  FETCH_ADP_LOGS,
  INITIATE_APPLICATION,
  INITIATE_DRAFT_APPLICATION,
  FETCH_SPECIFIC_ADP_LOGS,
  FETCH_AVP_LOGS,
  FETCH_SPECIFIC_AVP_LOGS,
  ADP_DEFAULT_FIELDS,
  CHECK_APPROVED_APP,
  AVP_CHECK_APPROVED_APP_BY_FIELD,
  CLEAR_APPROVAL_APPLICATION_LIST_BY_FIELD,
  CLEAR_DRAFT_STATE,
  CLEAR_APPROVED_APPLICATION_STATE,
  ADP_AVP_CANCEL_APPLICATION,
  INITIATE_AVP_APPLICATION,
  AVP_DEFAULT_FIELDS,
  GET_AVP_CATEGORIES,
  GET_AVP_FEE_MATRIX,
  MAKE_AVP_PAYMENT,
  DELETE_SPECIFIC_ADP_LOGS,
  RENEWAL_DAYS,
  ADP_SUSPEND_ACTION,
  ADP_REVOKE_ACTION,
  AVP_REVOKE_ACTION,
  AVP_SUSPEND_ACTION,
  CLEAR_DETAILS,
  CLEAR_ADP_DETAILS_STATUS,
  CLEAR_CANCEL_STATE,
  GET_ADP_APPLICATION_STAGE,
  CLEAR_STAGES_STATE,
  CLEAR_APPLICATION_STATUS,
  FETCH_USER_APPLICATIONS,
  ADP_RE_APPLY,
  AVP_RE_APPLY,
  AVP_RE_PRINT,
  ADP_RE_PRINT,
  GET_ADP_CATEGORIES,
  FETCH_SCHEDULES,
  SCHEDULE_APPOINTMENT,
  RESCHEDULE_APPOINTMENT,
  FETCH_SCHEDULE_SLOTS_BY_DATE,
  CLEAR_BOOKING_SCHEDULE,
  MAKE_ADP_PAYMENT,
  CLEAR_STATE,
  CLEAR_PAYMENT_STATE,
  SAVE_AS_DRAFT,
  GET_DEFECT_VEHICLES,
  GET_DEFECT_VEHICLE_DETAIL,
  UPDATE_MAINTENANCE,
  POST_COMMENTS,
  GET_COMMENTS,
  GET_MY_APPLICATIONS,
  GET_ADP_EXTERNAL_TRAINING,
  GET_PORTAL_USERS,
  GET_APPLICATION_DETAILS,
  UPDATE_DP,
  RETAKE_TRAINING,
  SUBMIT_DP,
  EMPTY_UPDATE_DP,
  APPEAL_VIOLATION,
  GET_CURRENT_TENANT_PORTAL_USERS,
  UPDATE_REQUIRED_DOCUMENTS,
  IMPORT_AVP_LOGS_DATA,
  CLEAR_IMPORT_AVP_STATE,
  UPLOAD_AVP_ATTACHMENTS,
  AVP_DRAFT_APPLICATION,
  CHECK_INITIATE_PERMIT,
  GET_TENANT_MANDATORY_DOCUMENTS,
  CLEAR_MANDATORY_DOCUMENT_ACTIONS,
  CLEAR_APPLICATION_SUCCESS_RESPONSE,
  CLEAR_INITIATED_PERMIT_STATE,
  DELETE_SAVE_AS_DRAFT_ADP_LOGS,
  DELETE_SAVE_AS_DRAFT_AVP_LOGS,
  GET_LOGS_EXCEL_EXPORT,
  CLEAR_REPRINT_STATE,
  FETCH_AVP_LOGS_TO_EXPORT,
  AVP_GLOBAL_DATASOURCE_LIST,
  GET_AVP_COMMENTS,
  ADDITIONAL_DRIVER_PERMIT_DOCS,
  ADDITIONAL_VEHICLE_PERMIT_DOCS
} from './types';

const BACKEND_API = 'BACKEND_API';

export const fetchAdpLogs = (page, sortKey, status, query, category_of_adp) => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: decodeURI(`/driver_permit/${page ? '?page=' : ''}${page || ''}
${sortKey ? '&sort=' : ''}${sortKey || ''}
${status ? '&status=' : ''}${status || ''}${query ? '&query=' : ''}${query || ''}${category_of_adp ? '&category_of_adp=' : ''}
${category_of_adp || ''}`),
    ...FETCH_ADP_LOGS
  }
});

export const checkInitiatePermit = (phone, email, initiated_to, driving_lic_num) => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: decodeURI(`/driver_permit/check_initiated/?
${phone ? '&phone=' : ''}${phone || ''}${initiated_to ? '&initiated_to=' : ''}${initiated_to || ''}
${email ? '&email=' : ''}${email || ''}${driving_lic_num ? '&driving_lic_num=' : ''}${driving_lic_num || ''}`),
    ...CHECK_INITIATE_PERMIT
  }
});


export const getMandatoryDocuments = tenant_id => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: decodeURI(`/vehicle_permit/${tenant_id}/get_tenant_documents/`),
    ...GET_TENANT_MANDATORY_DOCUMENTS
  }
});


export const clearMandatoryDocumentsActions = isCloseOpenModal => ({
  type: CLEAR_MANDATORY_DOCUMENT_ACTIONS,
  info: { isCloseOpenModal }
});

export const clearSuccessResponseOfApplicant = () => ({
  type: CLEAR_APPLICATION_SUCCESS_RESPONSE
});

export const fetchspecificAdpLogs = (id, PaymentStatus=false) => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/driver_permit/${id}/${PaymentStatus ? '?CheckPayment=true' : ''}`,
    ...FETCH_SPECIFIC_ADP_LOGS
  }
});

export const initiateApplication = data => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    url: '/driver_permit/initiate/',
    data,
    ...INITIATE_APPLICATION
  }
});

export const initiateDraftPermit = (data, orderId) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    url: `/driver_permit/${orderId}/intiate_draft_permit/`,
    data,
    ...INITIATE_DRAFT_APPLICATION
  }
});

export const checkExistingApprovedApplication = data => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: '/driver_permit/find_duplicate_permits/',
    ...CHECK_APPROVED_APP
  }
});

export const get_AVP_comments = (id, isRejected) => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/vehicle_permit/${id}/comments/?rejected=${isRejected}`,
    ...GET_AVP_COMMENTS
  }
});

export const handleClearApprovedApplicationState = () => ({
  type: CLEAR_APPROVED_APPLICATION_STATE
});

export const handleClearInitiateState = () => ({
  type: CLEAR_INITIATED_PERMIT_STATE
});

export const saveAirportSettings = data => ({
  type: 'SAVE_SETTINGS',
  data
});

export const saveOtp = otp => ({
  type: 'SAVE_OTP',
  otp
});

export const saveCurrentPage = currentPage => ({
  type: 'SAVE_CURRENT_PAGE',
  currentPage
});

export const saveUserData = userData => ({
  type: 'SAVE_USER_DATA',
  userData
});

export const initiateDraftAvp = (orderId, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    url: `/vehicle_permit/${orderId}/initiate_draft_permit/`,
    data,
    ...AVP_DRAFT_APPLICATION
  }
});

export const fetchAvpLogs = (page, sortKey, status, query, category_of_avp) => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: decodeURI(`/vehicle_permit/${page ? '?page=' : ''}${page || ''}${sortKey ? '&sort=' : ''}${sortKey || ''}
${status ? '&status=' : ''}${status || ''}${query ? '&query=' : ''}${query || ''}${category_of_avp ? '&category_of_avp=' : ''}
${category_of_avp || ''}`),
    ...FETCH_AVP_LOGS
  }
});

export const fetchspecificAvpLogs = id => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/vehicle_permit/${id}/`,
    ...FETCH_SPECIFIC_AVP_LOGS
  }
});

export const checkApprovedApplication = data => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: '/vehicle_permit/check_before_initiate/',
    ...AVP_CHECK_APPROVED_APP_BY_FIELD
  }
});

export const clearApproveApplicationInfo = () => ({
  type: CLEAR_APPROVAL_APPLICATION_LIST_BY_FIELD
});

export const fetchSchedules = () => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: '/portal_schedule/get_calender_details/?url_slug=driver_permit',
    ...FETCH_SCHEDULES
  }
});

export const scheduleAppointment = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    url: `/driver_permit/${id}/book_slot/`,
    data,
    ...SCHEDULE_APPOINTMENT
  }
});

export const reScheduleAppointment = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'PATCH',
    url: `/driver_permit/${id}/update_slot/`,
    data,
    ...RESCHEDULE_APPOINTMENT
  }
});

export const fetchScheduleSlotsByDate = (id, start, end) => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/portal_schedule/${id}/get_booked_slots/${end ? '?end_ts=' : ''}${end || ''}${start ? '&start_ts=' : ''}${start || ''}`,
    ...FETCH_SCHEDULE_SLOTS_BY_DATE
  }
});

export const clearScheduleSlotsAction = () => ({
  type: CLEAR_BOOKING_SCHEDULE
});

export const initiateAvpApplication = data => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    url: '/vehicle_permit/',
    data,
    ...INITIATE_AVP_APPLICATION
  }
});

export const getAvpDefaultFields = () => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: '/vehicle_permit/get_schema/',
    ...AVP_DEFAULT_FIELDS
  } });


export const getAvpCategories = () => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: '/vehicle_permit/get_avp_categories/',
    ...GET_AVP_CATEGORIES
  }
});

export const getAvpFeeMatrix = tenant_id => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/vehicle_permit/get_fee_matrix/${tenant_id ? '?tenant=' : ''}${tenant_id || ''}`,
    ...GET_AVP_FEE_MATRIX
  }
});

export const makeAvpPayment = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/vehicle_permit/${id}/make_avp_payments/`,
    ...MAKE_AVP_PAYMENT
  }
});

export const cancelApplication = (id, typeUrl, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/${typeUrl}/${id}/cancel_permit/`,
    ...ADP_AVP_CANCEL_APPLICATION
  }
});


export const getAvpGlobalDataSource = (id, fieldId) => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/vehicle_permit/${id}/get_global_datsource/`,
    fieldId,
    ...AVP_GLOBAL_DATASOURCE_LIST
  }
});

export const clearCancelState = () => ({
  type: CLEAR_CANCEL_STATE
});

export const getAdpApplicationStage = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'PATCH',
    data,
    url: `/driver_permit/${id}/training_draft/`,
    ...GET_ADP_APPLICATION_STAGE
  }
});

export const clearStageState = () => ({
  type: CLEAR_STAGES_STATE
});

export const clearApplicationStatus = () => ({
  type: CLEAR_APPLICATION_STATUS
});

export const getAdpDefaultFields = () => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: '/driver_permit/get_schema/',
    ...ADP_DEFAULT_FIELDS
  } });

export const getRenewal = () => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: '/driver_permit/get_additional_info/',
    ...RENEWAL_DAYS
  } });


export const handleSuspendApplication = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/driver_permit/${id}/suspend_permit/`,
    ...ADP_SUSPEND_ACTION
  }
});

export const clearDetailsState= () => ({
  type: CLEAR_DETAILS
});

export const clearAdpDetailsStatus = () => ({
  type: CLEAR_ADP_DETAILS_STATUS
});


export const handleRevokeApplication = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/driver_permit/${id}/revoke_permit/`,
    ...ADP_REVOKE_ACTION
  }
});

export const handleRevokeAVPApplication = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/vehicle_permit/${id}/revoke_permit/`,
    ...AVP_REVOKE_ACTION
  }
});

export const handleSuspendAVPApplication = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/vehicle_permit/${id}/suspend_permit/`,
    ...AVP_SUSPEND_ACTION
  }
});

export const makeAdpPayment = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/driver_permit/${id}/make_payments/`,
    ...MAKE_ADP_PAYMENT
  }
});

export const deletespecificAdpLog = id => ({
  type: BACKEND_API,
  payload: {
    method: 'DELETE',
    url: `/driver_permit/${id}/`,
    ...DELETE_SPECIFIC_ADP_LOGS,
    data: id
  },
  data: id
});

export const ADP_Re_Apply = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    url: `/driver_permit/${id}/re_open/`,
    data,
    ...ADP_RE_APPLY
  }
});

export const AVP_Re_Apply = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    url: `/vehicle_permit/${id}/re_open/`,
    data,
    ...AVP_RE_APPLY
  }
});

export const AVP_Re_Print = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/vehicle_permit/${id}/badge_reprint/`,
    ...AVP_RE_PRINT
  }
});

export const fetchUserApplications= data => ({
  type: FETCH_USER_APPLICATIONS,
  payload: data
});

export const ADP_Re_Print = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/driver_permit/${id}/badge_reprint/`,
    ...ADP_RE_PRINT
  }
});

export const clearReprintState = () => ({
  type: CLEAR_REPRINT_STATE
});

export const clearState= () => ({
  type: CLEAR_STATE
});

export const clearDraftState = () => ({
  type: CLEAR_DRAFT_STATE
});

export const clearPaymentState = () => ({
  type: CLEAR_PAYMENT_STATE
});

export const getDefectVehicles = (page, search, status) => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/vehicle_defect/?${page ? '&page=' : ''}${page || ''}${search ? '&query=' :''}${search|| ''}${status ? '&status=':''}${status||''}`,
    ...GET_DEFECT_VEHICLES
  }
});

export const getDefectVehicleDetail = id => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/vehicle_defect/${id}/`,
    ...GET_DEFECT_VEHICLE_DETAIL
  }
});

export const UpdateMaintenance = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/vehicle_defect/${id}/maintenance/`,
    ...UPDATE_MAINTENANCE
  }
});

export const uploadAvpAttachments = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/vehicle_permit/${id}/update_attachments/`,
    ...UPLOAD_AVP_ATTACHMENTS
  }
});

export const getAdpCategories = (category, query, fee_types, tenant_id) => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/driver_permit/get_adp_categories/${(category || query || fee_types || tenant_id) ? '?' : ''}${query ? 'query=' : ''}${query || ''}
${category ? 'category=' : ''}${category || ''}${fee_types ? 'fee_categories=' : ''}${fee_types || ''}
${tenant_id ? 'tenant=' : ''}${tenant_id || ''}`,
    apiInfo: { category, fee_types },
    ...GET_ADP_CATEGORIES
  }
});

export const postComments = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/vehicle_defect/${id}/comments/`,
    ...POST_COMMENTS
  }
});

export const getComments = id => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/vehicle_defect/${id}/comments/`,
    ...GET_COMMENTS
  }
});

export const getMyApplication = id => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/driver_permit/?user=${id}&disable_pagination=true`,
    ...GET_MY_APPLICATIONS
  }
});

export const getMyExternalTrainings = id => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/driver_permit/${id}/check_external_training/`,
    ...GET_ADP_EXTERNAL_TRAINING
  }
});

export const getPortalUsers = id => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/portal/?tenant=${id}`,
    ...GET_PORTAL_USERS
  }
});

export const getApplicationDetails = id => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: `/driver_permit/${id}/get_driver_permit/`,
    ...GET_APPLICATION_DETAILS
  }
});

export const updateDp = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/driver_permit/${id}/update_dp/`,
    ...UPDATE_DP
  }
});

export const retakeTraining = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/driver_permit/${id}/retake_training/`,
    ...RETAKE_TRAINING
  }
});

export const submitDp = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/driver_permit/${id}/submit_dp/`,
    ...SUBMIT_DP
  }
});

export const updateRequiredDocuments = (id, data, type) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    data,
    url: `/${type === 'adp' ? 'driver_permit' : 'vehicle_permit'}/${id}/update_attachments/`,
    ...UPDATE_REQUIRED_DOCUMENTS
  }
});

export const saveAsDraft = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'PATCH',
    data,
    url: `/driver_permit/${id}/save_driver_permit/`,
    ...SAVE_AS_DRAFT
  }
});

export const clearUpdatedDp = () => ({
  type: EMPTY_UPDATE_DP
});

export const appealViolation = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'POST',
    url: `/violations/${id}/create_violation_appeal/`,
    data,
    ...APPEAL_VIOLATION
  }
});

export const getCurrentTenantPortalUsers = () => ({
  type: BACKEND_API,
  payload: {
    method: 'GET',
    url: '/portal/get_current_tenant_portal_users/',
    ...GET_CURRENT_TENANT_PORTAL_USERS
  }
});

export const importAVPlogsData = data => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: '/vehicle_permit/import_avp_data/',
    data,
    ...IMPORT_AVP_LOGS_DATA
  }
});

export const clearImportState = () => ({
  type: CLEAR_IMPORT_AVP_STATE
});

export const deleteSaveAsDraftAdpLog = id => ({
  type: BACKEND_API,
  payload: {
    method: 'delete',
    url: `/driver_permit/${id}/`,
    ...DELETE_SAVE_AS_DRAFT_ADP_LOGS
  }
});

export const deleteSaveAsDraftAvpLog = id => ({
  type: BACKEND_API,
  payload: {
    method: 'delete',
    url: `/vehicle_permit/${id}/`,
    ...DELETE_SAVE_AS_DRAFT_AVP_LOGS
  }
});

export const fetch_Permit_Logs_Excel_Export = (page, query, status, category_of_adp) => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/driver_permit/excel_export/?${page ? '&page=' : ''}${page || ''}
${query ? '&query=' : ''}${query || ''}${category_of_adp ? '&category_of_adp=' : ''}
${category_of_adp || ''}${status ? '&status=' : ''}${status || ''}`,
    ...GET_LOGS_EXCEL_EXPORT
  }
});

export const fetch_Avp_Permit_Logs_Excel_Export = (page, query, status, category_of_avp) => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/vehicle_permit/excel_export/?${page ? '&page=' : ''}${page || ''}
${query ? '&query=' :''}${query|| ''}${category_of_avp ? '&category_of_avp=' : ''}
${category_of_avp || ''}${status ? '&status=' : ''}${status || ''}`,
    ...FETCH_AVP_LOGS_TO_EXPORT
  }
});

export const addDriverPermitAditionalDocs = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'patch',
    url: `/driver_permit/${id}/`,
    data,
    ...ADDITIONAL_DRIVER_PERMIT_DOCS
  }
});

export const addVehiclePermitAditionalDocs = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'patch',
    url: `/vehicle_permit/${id}/update_additional_attachments/`,
    data,
    ...ADDITIONAL_VEHICLE_PERMIT_DOCS
  }
});
